var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.712 4.78862L12.7878 2.24968C12.2847 2.03406 11.7153 2.03406 11.2122 2.24968L5.28797 4.78862C4.47806 5.13572 3.99073 5.972 4.08804 6.84777L4.73939 12.7099C4.93906 14.5069 5.8263 16.157 7.21529 17.3144L10.7196 20.2347C11.4613 20.8528 12.5387 20.8528 13.2804 20.2347L16.7847 17.3144C18.1737 16.157 19.0609 14.5069 19.2606 12.7099L19.912 6.84777C20.0093 5.972 19.5219 5.13572 18.712 4.78862Z",
    stroke: "#3B404B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChield);
export default __webpack_public_path__ + "static/media/Chield.cb3504a8b43e0ca83596ee89604611d3.svg";
export { ForwardRef as ReactComponent };